import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
	selector: 'pagination',
	templateUrl: './pagination.component.html',
	styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
	@Input() totalItemNo: number;
	@Input() itemPerPage: number = 10;
	@Input() pageLimit: number;
	@Input() noTotalItem;
	@Input() disableDescription: boolean;
	@Input() temporalTotal;
	@Input() basicPagination: boolean;
	paginatedRage: number = 1;
	@Input() totalPage: number = 0;
	@Input() currentPageNo;
	@Input() withGrayNote: boolean = false;
	paginationArray: number[] = [];
	pageText: string;
	pageInput = 1;
	@Output() currentPageEvent = new EventEmitter<number>();

	addNewEvent(value: number) {
		this.currentPageEvent.emit(value);
	}

	previous(value: number) {
		let page: number = value > 1 ? value - 1 : 1;
		this.currentPageNo = page;
		this.setPageArray(page, this.pageLimit);
		this.addNewEvent(page);
	}

	next(value: number) {
		let page: number = value > this.totalPage ? this.totalPage : value + 1;
		this.currentPageNo = page;
		this.setPageArray(page, this.pageLimit);
		this.addNewEvent(page);
	}

	specialCasePrevious() {
		let page: number = 1;
		this.currentPageNo = page;
		this.setPageArray(page, this.pageLimit);
		this.addNewEvent(page);
	}

	specialCaseNext() {
		let page: number = this.totalPage;
		this.currentPageNo = page;
		this.setPageArray(page, this.pageLimit);
		this.addNewEvent(page);
	}

	changePage(clickedNo: number) {
		if (clickedNo !== this.currentPageNo) {
			this.currentPageNo = clickedNo;
			this.setPageArray(clickedNo, this.pageLimit);
			this.addNewEvent(clickedNo);
		}
	}

	getShowDescription() {
		if (this.noTotalItem === 0) {
			return false;
		}
		return !this.disableDescription;
	}

	getEndText(x) {
		if (x > this.totalItemNo) {
			return this.totalItemNo;
		}
		return x;
	}

	getStartText(x) {
		return (x - 1) * this.itemPerPage + 1;
	}

	setPageText(clickedNo: number): void {
		let x: number = clickedNo * this.itemPerPage;
		let isGreaterThanItemSize: boolean = x > this.totalItemNo;

		if (this.noTotalItem) {
			this.pageText = `${clickedNo} - ${this.temporalTotal}`;
		} else if (isGreaterThanItemSize) {
			if (clickedNo > 1) this.pageText = `${this.getStartText(clickedNo)} - ${this.getEndText(x)}`;
			else {
				this.pageText = `${clickedNo} - ${this.getEndText(x)}`;
			}
		} else {
			if (clickedNo > 1) this.pageText = `${this.getStartText(clickedNo)} - ${this.getEndText(x)}`;
			else this.pageText = `${clickedNo} - ${this.getEndText(x)}`;
		}
	}

	constructor() {}

	ngOnInit(): void {
		this.pageInput = this.currentPageNo;
		this.setPageRage();
		this.setPageArray(this.currentPageNo, this.pageLimit);
	}

	setPageRage() {
		this.paginatedRage = Math.ceil(this.getTotalPage() / this.pageLimit);
	}

	getTotalPage() {
		//if(this.totalPage === 0){
		return (this.totalPage = Math.ceil(this.totalItemNo / this.itemPerPage));
		// }
		// else {
		//   return this.totalPage;
		// }
	}

	setPageArray(currencyPage: number, limit: number) {
		//Improved pagination formula
		let begin = currencyPage;

		let end = Math.round(currencyPage + limit);
		this.paginationArray = [];
		for (let i: number = begin; i < end; i++) {
			if (i <= this.totalPage) {
				this.paginationArray.push(i);
			}
		}
		if (this.paginationArray.length) {
			this.setPageText(currencyPage);
		}
	}
}
